

import { X } from 'lucide-react';
import { useBlogStore } from '../../store/useBlogStore';
import { PublishSection } from './PublishSection';
import { SEOSection } from './SEOSection';
import { FeaturedImageSection } from './FeaturedImageSection';
import { CategoriesSection } from './CategoriesSection';
import { TagsSection } from './TagsSection';
import { ExcerptSection } from './ExcerptSection';
import { VisibilitySection } from './VisibilitySection';
import { SlugSection } from './SlugSection';
import { AuthorSection } from './AuthorSection';

export const PostSettingsPanel = () => {
  const { setActivePanel } = useBlogStore();
  return (
    <aside className="w-80 border-l bg-card flex flex-col h-full shrink-0">
      <div className="h-14 border-b flex items-center justify-between px-4 sticky top-0 bg-card z-10">
        <h2 className="font-semibold text-sm">Post Settings</h2>
        <button onClick={() => setActivePanel(null)} className="p-1.5 hover:bg-muted rounded-md text-muted-foreground">
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-6">
        <PublishSection />
        <VisibilitySection />
        <SlugSection />
        <FeaturedImageSection />
        <ExcerptSection />
        <CategoriesSection />
        <TagsSection />
        <AuthorSection />
        <SEOSection />
      </div>
    </aside>
  );
};
